<div
  [ngSwitch]="item.type"
  *ngFor="let item of model.elements || []"
  (click)="onClick($event)"
  (mouseup)="mouseup($event)"
  (mousedown)="mousedown($event)"
  (auxclick)="auxclick($event)"
  (contextmenu)="auxclick($event)"
  #snippet
>
  <ng-container *ngSwitchCase="'rich_text'">
    <result-rich-text-block (invoke)="invoke.emit($event)" [model]="item" [highlights]="highlights"> </result-rich-text-block>
  </ng-container>
  <ng-container *ngSwitchCase="'code'">
    <result-code-block [model]="item" [highlights]="highlights"> </result-code-block>
  </ng-container>
  <ng-container *ngSwitchCase="'markdown_block_snippet'">
    <result-markdown-block [model]="item" [highlights]="highlights"> </result-markdown-block>
  </ng-container>
</div>
